<div class="search-parent-wrapper">
  <div class="search-container mb-3" [ngClass]="isFocus ? 'input-focused' : ''">
    <app-global-search-input
      (searchByKey)="keySearchResult($event)"
      (searchKeyLength)="keySearchLength($event)"
      (searchByEnter)="searchByEnter($event)"
      (focusEvent)="isFocus = $event"
      [width]="searchResult.length && !isLoading"
      (keyupSearch)="onKeyup($event)"
    ></app-global-search-input>
  </div>
  <!-- *ngIf="!storeService.filteredResult; else showFilteredResult" -->
  <ng-container>
    <div
      class="container search-drawer"
      [ngClass]="[
        isDrawerVisible ? 'd-block' : 'd-none',
        isFocus ? 'search-drawer--focused' : ''
      ]"
    >
      <div
        class="search-result-container"
        [ngClass]="
          searchResult.length && !isLoading
            ? 'width-75 ms-auto box-shadow-huge'
            : 'w-100'
        "
      >
        <div class="row" *ngIf="!suggestedResult">
          <ng-container *ngIf="searchKeyLength == 0; else keyResult">
            <ng-container>
              <h5
                class="search-heading d-flex justify-content-between"
                *ngIf="recentSearch && recentSearch.length > 0"
              >
                {{ "global-search.recent-searches" | translate }}
                <span class="material-icons" (click)="removeRecent()">
                  <img
                    loading="lazy"
                    fetchpriority="high"
                    src="https://media.umangapp.in/cdn/web/theme/icons/delete1.svg"
                    alt=""
                  />
                </span>
              </h5>
              <div class="d-flex" style="flex-wrap: wrap">
                <div
                  class="recentSearch d-flex align-items-center cursor-pointer"
                  *ngFor="let item of recentSearch"
                  (click)="keyListRecentClick(item?.alises)"
                >
                  <span class="searching-icon d-flex">
                    <img
                      src="assets/images/history-icon.svg"
                      alt="history"
                      width="18"
                      height="18"
                    />
                  </span>
                  <span class="searching-data d-flex">{{ item?.alises }}</span>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <h5 class="search-heading">
                {{ "global-search.mostSearches" | translate }}
              </h5>
              <div class="d-flex justify-content-between">
                <div class="trending-container">
                  <p class="trending-title mt-1">
                    {{ "global-search.services" | translate }}
                  </p>
                  <ul class="pe-2 ps-0">
                    <li
                      *ngFor="let item of trend?.services"
                      class="pt-0 no-style"
                      (click)="navigateToDeptInfo(item, 'service')"
                    >
                      <span
                        [matTooltip]="
                          item?.service_name + ' > ' + item?.department_name
                        "
                        class="cursor-pointer searching-data-trending d-block p-0 text-truncate"
                        >{{
                          item?.service_name + " > " + item?.department_name
                        }}</span
                      >
                    </li>
                  </ul>
                </div>
                <div class="trending-container">
                  <p class="trending-title mt-1">
                    {{ "global-search.departments" | translate }}
                  </p>
                  <ul class="pe-2 ps-0">
                    <li
                      *ngFor="let item of trend?.departments"
                      class="pt-0 no-style"
                      (click)="navigateToDeptInfo(item, 'department')"
                    >
                      <span
                        [matTooltip]="item?.department_name"
                        class="cursor-pointer searching-data-trending d-block p-0 text-truncate"
                        >{{ item?.department_name }}</span
                      >
                    </li>
                  </ul>
                </div>

                <div class="trending-container">
                  <p class="trending-title mt-1">
                    {{ "global-search.digilocker" | translate }}
                  </p>
                  <ul class="pe-2 ps-0">
                    <li
                      (click)="navigateToDigilocker()"
                      *ngFor="let item of trend?.documents"
                      class="pt-0 no-style"
                      role="button"
                    >
                      <span
                        [matTooltip]="item?.doc_desc"
                        class="searching-data-trending d-block p-0 text-truncate"
                        >{{ item?.doc_desc }}</span
                      >
                    </li>
                  </ul>
                </div>
                <div class="trending-container">
                  <p class="trending-title mt-1">
                    {{ "global-search.schemes" | translate }}
                  </p>
                  <ul class="pe-2 ps-0">
                    <li
                      *ngFor="let item of trend?.schemes"
                      class="pt-0 no-style"
                      (click)="navigateToScheme(item)"
                    >
                      <span
                        [matTooltip]="item?.scheme_name"
                        class="cursor-pointer searching-data-trending d-block p-0 text-truncate"
                        >{{ item?.scheme_name }}</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </ng-container>

            <ng-template #skeleton>
              <div class="loader-wrapper" *ngFor="let item of [1, 2, 3, 4]">
                <div class="loader">
                  <div class="thumbnail"></div>
                  <div class="line"></div>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #keyResult>
            <div class="col-md-4 mb-2">
              <h4 class="search-heading">
                {{ "global-search.suggestions" | translate }}
              </h4>
              <ul
                class="search-list"
                *ngIf="searchKeyResult?.length; else noSuggestion"
              >
                <li
                  *ngFor="let item of searchKeyResult"
                  (click)="getSearchResult(item)"
                  role="button"
                  class="d-flex align-items-center"
                >
                  <img
                    src="assets/images/search-icon.svg"
                    alt="search"
                    width="20"
                  />
                  <span class="ms-0 ps-2">
                    {{ item?.alises }}
                  </span>
                </li>
              </ul>
              <ng-template #noSuggestion>
                {{ "global-search.no-suggestions" | translate }}
              </ng-template>
            </div>
          </ng-template>
        </div>
        <div class="row" *ngIf="suggestedResult">
          <div class="search-body-content-inner-suggestions">
            <!-- *ngIf="suggestedResult" -->
            <ul>
              <!-- *ngIf="suggestedResult['services']" -->
              <li
                *ngFor="let item of suggestedResult"
                class="py-2 cursor-pointer"
              >
                <div [ngSwitch]="item.index" class="w-100">
                  <div
                    (click)="navigateToDeptInfo(item, 'department')"
                    class="d-flex align-items-center justify-content-center w-100"
                    *ngSwitchCase="'departments'"
                  >
                    <div
                      class="suggestion-default-icon d-flex align-items-center justify-content-center"
                    >
                      <div class="services-icon">
                        <app-services-icon-svg></app-services-icon-svg>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-start flex-column justify-content-center w-100 px-3"
                    >
                      <p class="d-flex align-items-center">
                        {{ item?.department_name }}
                      </p>
                      <small>In Departments</small>
                    </div>
                    <div
                      *ngIf="item?.logo_url"
                      class="suggestion-dept-icon d-flex align-items-center justify-content-center"
                    >
                      <img [src]="item?.logo_url" alt="" />
                    </div>
                  </div>
                  <div
                    (click)="navigateToDeptInfo(item, 'service')"
                    class="d-flex align-items-center justify-content-center w-100"
                    *ngSwitchCase="'services'"
                  >
                    <div
                      class="suggestion-default-icon d-flex align-items-center justify-content-center"
                    >
                      <div class="services-icon">
                        <app-services-icon-svg></app-services-icon-svg>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-start flex-column justify-content-center w-100 px-3"
                    >
                      <p class="d-flex align-items-center">
                        {{ item?.service_name }}
                        <span>({{ item?.department_name }})</span>
                      </p>
                      <small>In Services</small>
                    </div>
                    <div
                      *ngIf="item?.image"
                      class="suggestion-dept-icon d-flex align-items-center justify-content-center"
                    >
                      <img [src]="item?.image" alt="" />
                    </div>
                  </div>
                  <div
                    (click)="navigateToDigilocker()"
                    class="d-flex align-items-center justify-content-center w-100"
                    *ngSwitchCase="'documents'"
                  >
                    <div
                      class="suggestion-default-icon d-flex align-items-center justify-content-center"
                    >
                      <div class="documents-icon">
                        <app-documents-icon-svg></app-documents-icon-svg>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-start flex-column justify-content-center w-100 px-3"
                    >
                      <p class="d-flex align-items-center">
                        {{ item?.doc_desc }}<span>({{ item?.name }})</span>
                      </p>
                      <small>In Documents</small>
                    </div>
                    <div
                      *ngIf="item?.logo"
                      class="suggestion-dept-icon d-flex align-items-center justify-content-center"
                    >
                      <img [src]="item?.logo" alt="" />
                    </div>
                  </div>
                  <div
                    (click)="navigateToScheme(item)"
                    class="d-flex align-items-center justify-content-center w-100"
                    *ngSwitchCase="'schemes'"
                  >
                    <div
                      class="suggestion-default-icon d-flex align-items-center justify-content-center"
                    >
                      <div class="scheme-icon">
                        <app-scheme-icon-svg></app-scheme-icon-svg>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-start flex-column justify-content-center w-100 px-3"
                    >
                      <p class="d-flex align-items-center">
                        {{ item?.scheme_name }}
                      </p>
                      <small>In Schemes</small>
                    </div>
                    <div
                      class="suggestion-dept-icon d-flex align-items-center justify-content-center"
                    >
                      <div class="umang-logo">
                        <app-umang-logo-svg></app-umang-logo-svg>
                      </div>
                    </div>
                  </div>
                  <!-- <span *ngSwitchCase="'services'">In Service</span>
                  <span *ngSwitchCase="'schemes'">In Schemes</span> -->
                </div>
              </li>
              <!-- <ng-container>
                  <li *ngFor="let item of suggestedResult['services']">
                    <p>{{item?.service_name}}</p>
                    <span>Service</span>
                  </li>
                </ng-container>
                <ng-container>
                  <li *ngFor="let item of suggestedResult['departments']" (click)="goToDept(item, 'department')">
                    <p>{{item?.department_name}}</p>
                    <span>Department</span>
                  </li>
                </ng-container>
                <ng-container>
                  <li *ngFor="let item of suggestedResult['schemes']" (click)="navigateToScheme(item)">
                    <p>{{item?.scheme_name}}</p>
                    <span>Scheme</span>
                  </li>
                </ng-container> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div *ngIf="isLoading; else showFilteredResult"></div>
  <ng-template #showFilteredResult>
    <div class="container container--filter">
      <ng-container *ngIf="searchResult.length && !isLoading; else noData">
        <div class="row">
          <div class="col-md-3 filter-col">
            <div class="filter-wrapper">
              <ul class="filter-items mb-2">
                <li class="filter-items__label">
                  {{ "global-search.filter-by" | translate }}
                </li>
                <li
                  (click)="filterByRegion('A')"
                  [ngClass]="clickedRegion == 'A' ? 'active' : ''"
                >
                  {{ "states.all" | translate }}
                </li>
                <li
                  (click)="filterByRegion('C')"
                  [ngClass]="clickedRegion == 'C' ? 'active' : ''"
                >
                  {{ "stats.central" | translate }}
                </li>
                <li
                  class="has-dropdown"
                  (click)="toggleState()"
                  [ngClass]="[
                    !filteredStates.length ? 'disabled' : '',
                    regional ? 'active' : ''
                  ]"
                >
                  {{ "global-search.regional" | translate }}
                  <img src="assets/images/plus.svg" alt="" *ngIf="!regional" />
                  <img src="assets/images/minus.svg" alt="" *ngIf="regional" />
                </li>
              </ul>
              <ul
                class="filter-items filter-items--sub"
                [ngClass]="regional ? 'opened' : ''"
              >
                <li
                  *ngFor="let item of filteredStates"
                  (click)="filterByState(item)"
                  [ngClass]="clickedState == item.stateId ? 'active' : ''"
                >
                  {{ item.stateName | translate }}
                </li>
              </ul>
              <hr />
              <ul
                class="filter-items"
                [ngClass]="!searchedKeyResult ? 'mb-2 sm-mb-4' : ''"
              >
                <li class="filter-items__label">
                  {{ "global-search.category" | translate }}
                </li>
                <li
                  *ngFor="let item of categoryList"
                  (click)="filterByCategory(item)"
                  [ngClass]="clickedCategory == item.categoryId ? 'active' : ''"
                  role="button"
                >
                  {{ item.categoryName }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-9">
            <ul class="chips mb-4">
              <li
                (click)="filterByType('S')"
                [ngClass]="clickedType == 'S' ? 'active' : ''"
                role="button"
              >
                {{ "dept-details.services" | translate }}
              </li>
              <li
                (click)="filterByType('D')"
                [ngClass]="clickedType == 'D' ? 'active' : ''"
                role="button"
              >
                {{ "stats.departments" | translate }}
              </li>
            </ul>
            <p>
              {{ isValid ? searchResult.length : displayList.count }}
              {{ "global-search.result-found" | translate }}
            </p>
            <ul class="search-result-lists d-flex flex-column">
              <ng-container *ngIf="displayList.list.length; else noData">
                <ng-container *ngFor="let item of displayList.list">
                  <li
                    class="search-result-list d-flex align-items-center cursor-pointer"
                    (click)="navigateToDeptInfo(item, 'department')"
                  >
                    <div class="search-result-list__img">
                      <img [src]="item?.image" alt="" />
                    </div>

                    <div
                      class="search-result-list__content d-flex flex-column align-items-start ps-2"
                    >
                      <p class="mb-1">{{ item?.service_name }}</p>
                      <span>{{ item?.category_name }}</span>
                    </div>
                  </li>
                </ng-container>
              </ng-container>
              <ng-template #noData
                ><div
                  class="no-record d-flex align-items-center justify-content-center flex-column"
                >
                  <img
                    src="assets/images/norecord.svg"
                    alt=""
                    class="mb-3"
                    width="120px"
                  />
                  <p class="mb-0">
                    {{ "global-search.no-records-found" | translate }}
                  </p>
                </div>
              </ng-template>
            </ul>
          </div>
        </div>
      </ng-container>
      <ng-template #noData>
        <div
          class="no-record d-flex align-items-center justify-content-center flex-column"
          style="min-height: 200px"
          *ngIf="!isDrawerVisible"
        >
          <img
            src="assets/images/norecord.svg"
            alt=""
            class="mb-3"
            width="120px"
          />
          <p class="mb-0">{{ "global-search.no-records-found" | translate }}</p>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>
